import { useCallback, useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import type { Update } from "../types/update";

export type { Update } from "../types/update";

interface UseUpdatesOptions {
  limit?: number;
}

export function useUpdates(options: UseUpdatesOptions = {}) {
  const { limit = 5 } = options;
  const [updates, setUpdates] = useState<Update[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    let q = supabase
      .from("updates")
      .select("id, title, description, created_at")
      .order("created_at", { ascending: false });

    if (limit != null) {
      q = q.limit(limit);
    }

    const { data, error: fetchError } = await q;

    if (fetchError) {
      setError(fetchError.message);
      setUpdates([]);
    } else {
      setUpdates((data as Update[]) ?? []);
    }
    setLoading(false);
  }, [limit]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { updates, loading, error, refetch: fetch };
}
